import { useEffect } from "react"
import { useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetAdDetail = () => {
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/column/ad/${idx}`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "ad_idx") setAlert("광고 idx 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("광고 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetAdDetail